import { z } from 'zod';

export const debtSecurityFormBaseSchema = z.object({
  isin: z.string()
    .length(12, 'ISIN must be exactly 12 characters')
    .regex(/^[A-Z0-9]+$/, 'ISIN must be alphanumeric'),
  issuerId: z.string().uuid('Please select an issuer'),
  couponRate: z.number()
    .min(0, 'Coupon rate must be at least 0')
    .max(100, 'Coupon rate cannot exceed 100'),
  nominalPrice: z.number().positive('Nominal price must be positive'),
  quantity: z.number().positive('Quantity must be positive'),
  tenor: z.string().min(1, 'Tenor is required'),
  maturityDate: z.string().refine(
    (date) => new Date(date) > new Date(),
    'Maturity date must be in the future'
  ),
  currency: z.string().length(3, 'Currency must be 3 characters'),
  issueNumber: z.string().min(1, 'Issue number is required'),
  notes: z.string().optional(),
  issueDate: z.string().optional().nullable(),
});

export const debtSecurityFormSchema = debtSecurityFormBaseSchema.superRefine((data, ctx) => {
  if (data.issueDate && data.maturityDate) {
    if (new Date(data.issueDate) > new Date(data.maturityDate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Issue date must not be after the maturity date',
        path: ['issue_date'],
      });
    }
  }
});

export type DebtSecurityFormData = z.infer<typeof debtSecurityFormSchema>;
